const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

window.settings = isLocal ? {
  "API_SERVER": "127.0.0.1",
  "API_PORT": 7575,
  "API_PROTOCOL": "http",
} : {
  "API_SERVER": "acc.realty-admin.com",
  "API_PORT": 0,
  "API_PROTOCOL": "https",
};
